<template>
  <div id="button-root" @click="proxyOpen">
    <div id="button-layout" :style="buttonLayoutStyle">
      <div id="top-open">
        <DownloadAppButton
          ref="openBtn"
          @actionDownload="download"
          :downloadBtnText="btn_text"
          :openBtnStyleObj="topOpenStyleObj"
        />
        <div class="download_tip" v-show="showDownloadTips">{{ t('tip.upgradeForMore') }}</div>
      </div>
    </div>
    <UnsupportOpenPage :show_tip="show_tip" @dimiss="dismiss"></UnsupportOpenPage>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, type CSSProperties, reactive, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import OpenWpsBridge from '../bridge/OpenWpsBridge';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import UnsupportOpenPage from './UnsupportOpenPage.vue';
import { OpenButtonStyle } from './OpenAppButton.vue';
import DownloadAppButton from './DownloadAppButton.vue';
import AppLinkStat from '../stats/AppLinkStat';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';

const show_tip = ref(false);
const { t } = useI18n();
const btn_text = ref(t('common.download'));

const openBtn = ref();

const topOpenStyleObj = reactive<OpenButtonStyle>({
  background: '#3B64FC',
  'border-radius': '18px',
  'border-width': '0px',
  width: '280px',
  height: '48px',
  'font-size': '16px',
  color: '#fff',
  'text-decoration-line': 'none',
});

const buttonLayoutStyleObj = reactive({
  height: 'auto',
  'margin-top': 'auto',
  'margin-bottom': '50px',
});

const buttonLayoutStyle = computed(() => {
  return {
    ...buttonLayoutStyleObj,
  } as CSSProperties;
});

const showDownloadTips = ref(false);

function dismiss() {
  show_tip.value = false;
}

function proxyOpen() {
  openBtn.value.$.vnode.el?.click();
}

function download() {
  if (DeviceEnvUtil.isUnsupportDownload()) {
    show_tip.value = true;
  } else {
    show_tip.value = false;
    OpenWpsBridge.download();
  }
  AppLinkStat.eventDownloadClick(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
    DeviceEnvUtil.getPlatform(),
    `${show_tip.value}`,
  );
}

onMounted(() => {
  if (!DeviceEnvUtil.isUnsupportDownload() && AbilityParamsUtil.isAutoJumpDownload()) {
    setTimeout(() => {
      OpenWpsBridge.download();
    }, 1000);
  }
  showDownloadTips.value = AbilityParamsUtil.isAutoJumpDownload();
});
</script>

<style scoped>
#button-root {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

#download-tip {
  margin-bottom: 12px;
  font-size: 12px;
  color: #2453de;
}

#bottom-wrap {
  position: relative;
  margin: auto;
  margin-top: 16px;
  width: 280px;
  height: 48px;
  background-color: transparent;
}

#bottom-download {
  position: absolute;
  left: 0;
  width: 280px;
  height: 48px;
  font-size: 16px;
  border-width: 0;
  border-radius: 8px;
  color: rgb(13 13 13 / 90%);
  background-color: rgb(231 236 240 / 100%);
  text-decoration-line: none;
}

#top-open {
  width: auto;
}

#bottom-open {
  position: absolute;
  left: 0;
  width: 100%;
  height: 48px;
}

.download_tip {
  margin-top: 12px;
  font-size: 12px;
  color: #2453de;
}
</style>
